import { WorkClothesTypeService } from './work-clothes-type.service';
import { WorkClothesType } from './work-clothes-type.interface';
const service = new WorkClothesTypeService();

interface WorkClothesTypeState {
   workClothesTypes: Array<WorkClothesType>;
}

const state: WorkClothesTypeState = {
   workClothesTypes: [],
};

const getters = {
   workClothesTypes(state: WorkClothesTypeState) {
      return state.workClothesTypes;
   },
};

const mutations = {
   SET_WORK_CLOTHES_TYPES(state: WorkClothesTypeState, workClothesTypes: Array<WorkClothesType>) {
      state.workClothesTypes = workClothesTypes;
   },
};

const actions = {
   async getWorkClothesTypes(context: any) {
      return service.getWorkClothesTypes().then((response) => {
         context.commit('SET_WORK_CLOTHES_TYPES', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
